import React, { useState } from 'react';
import Row from '../../../../components/tag/Row';
import Span from '../../../../components/tag/Span';
import ClosestContactInfo from './ClosestContactInfo';
import { FormattedMessage } from 'react-intl';
import Form from '@rjsf/core';
import ObjectFieldTemplate from '../../../../components/form/ObjectFieldTemplate';
import ModalWrapper from './ModalWrapper';
import { MAX_CONTACT_AMOUNT } from '../../../../definitions/ContactConstants';
import SetCloseContactNotification from './SetCloseContactNotification';
import { formType } from './ContactFormContainer';
import Alert from '../../../../components/Alert';
import SetCloseContactModalContent from './modals/SetCloseContactModalContent';
import CannotAddRelativeModal from './modals/CannotAddContactModalContent';
import { getFullName } from './EditContactForm';

let { id: module_id } = module;

const ListContactsField = (props) => {
  let { formData, formContext } = props;

  const { firstName, lastName, relation, closestContact, phone, id } = formData;
  const {
    setForm,
    hasCloseContact,
    showSetCloseContactModal,
    contactFeatureOn,
  } = formContext;

  return (
    <Row className={'relative-row'}>
      <Span len={5}>
        {firstName} {lastName}
        {relation && (
          <>
            , <FormattedMessage id={`relation.${relation}`} />
          </>
        )}
        {/* Show info if contact is close contact */}
        {hasCloseContact && closestContact && <ClosestContactInfo />}
      </Span>
      <Span len={4}>
        <strong>
          <FormattedMessage id={'phone'} />
        </strong>{' '}
        {phone}
      </Span>
      <Span len={3}>
        {contactFeatureOn && (
          <div>
            {/* Edit contact button */}

            <button
              className={'edit-relative-button'}
              onClick={(e) => {
                e.preventDefault();
                setForm({ name: formType.EDIT, id });
              }}
            >
              <FormattedMessage id={`edit`}>
                {(txt) => (
                  <>
                    <i className="ot-notification__icon icon-edit" />
                    {txt}
                  </>
                )}
              </FormattedMessage>
            </button>

            <br />
            {/* If contact is not close contact or if there are no close contacts,
              show button to set close contact
          */}
            {(!closestContact || !hasCloseContact) && (
              <button
                onClick={(e) => {
                  e.preventDefault();
                  showSetCloseContactModal(formData);
                }}
                className={'choose-close-relative-button'}
              >
                <FormattedMessage id={`${module.id}.choose.close.contact`} />
              </button>
            )}
          </div>
        )}
      </Span>
    </Row>
  );
};

const listContactsSchema = {
  title: '',
  type: 'array',
  items: {
    type: 'array',
    items: {
      type: 'object',
      properties: {
        id: { type: 'string' },
        relation: { type: 'string' },
        firstName: { type: 'string', default: '' },
        lastName: { type: 'string', default: '' },
        phone: { type: 'string', default: '' },
      },
    },
  },
};

const listContactsUiSchema = {
  items: {
    'ui:field': ListContactsField,
  },
  'ui:grid': {
    col: 12,
    children: ['items'],
  },
  'ui:options': {
    orderable: false,
    removable: false,
    addable: false,
  },
};

export const AddContactButton = ({
  setForm,
  canAddPatient,
  showCannotAddRelativeModal,
}) => {
  const handleAddContact = (e) => {
    e.preventDefault();
    canAddPatient
      ? setForm({ name: formType.ADD })
      : showCannotAddRelativeModal(e);
  };

  return (
    <Row style={{ padding: '20px 0' }}>
      <Span className={'text-center'}>
        <button className={'edit-relative-button'} onClick={handleAddContact}>
          <i className="ot-notification__icon icon-plus" />
          <FormattedMessage id={`${module_id}.add.contact`} />
        </button>
      </Span>
    </Row>
  );
};

const ListContactsForm = ({ contacts, error, actions, formContext }) => {
  let [modal, setModal] = useState(null);
  let { setForm, hasContacts, hasCloseContact, contactFeatureOn } = formContext;

  const showSetCloseContactModal = (formData) => {
    setModal({
      content: SetCloseContactModalContent,
      props: {
        name: getFullName(formData),
        setCloseContact: () => actions.setCloseContact(formData.id),
      },
    });
  };

  const showCannotAddRelativeModal = (e) => {
    e.preventDefault();

    setModal({
      content: CannotAddRelativeModal,
    });
  };

  return (
    <div className={'list-relatives'}>
      {contactFeatureOn && hasContacts && !hasCloseContact && (
        <SetCloseContactNotification />
      )}
      {hasContacts ? (
        <Form
          formData={contacts}
          uiSchema={listContactsUiSchema}
          schema={listContactsSchema}
          formContext={{
            ...formContext,
            showSetCloseContactModal,
          }}
          ObjectFieldTemplate={ObjectFieldTemplate}
        >
          <div style={{ display: 'none' }} />
        </Form>
      ) : (
        <div style={{ padding: '10px', textAlign: 'center' }}>
          {contactFeatureOn ? (
            <FormattedMessage id={`${module_id}.no.contacts`} />
          ) : (
            <FormattedMessage id={`${module_id}.no.contacts.old`} />
          )}
        </div>
      )}
      {error && (
        <Alert
          type={'error'}
          dismiss={{ func: actions.resetError }}
          message={`${module_id}.error.${error}`}
        />
      )}
      {contactFeatureOn && (
        <AddContactButton
          setForm={setForm}
          canAddPatient={contacts && contacts.length < MAX_CONTACT_AMOUNT}
          showCannotAddRelativeModal={showCannotAddRelativeModal}
        />
      )}
      {
        /* Old style notification to update contacts via a professional */
        !contactFeatureOn && (
          <FormattedMessage id={`${module_id}.update.contacts.old`}>
            {(txt) => <p className="relative-update-info-old">{txt}</p>}
          </FormattedMessage>
        )
      }
      <ModalWrapper modal={modal} closeModal={() => setModal(null)} />
    </div>
  );
};

export default ListContactsForm;
